/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const WebhookBrokerOrganizationCustomerPost = {
  id: 'webhook.broker.organization-customer.post',
  tag: 'Webhook',
  summary: 'Set up webhook broker for organization customer',
  description: 'Set up webhook broker for organization customer',
  method: 'post',
  route: () => `/webhook/broker/organization-customer`,
  request: {
    body: {
      required: true,
      content: {
        'application/json': {
          schema: z.strictObject({
            organization: z.strictObject({
              name: z.string().min(1),
              companyName: z.string().min(1),
              description: z.string().nullable().optional(),
              email: z.string().email().optional(),
              vatNumber: z.string().optional(),
              language: ZodTypes.Language,
              address: z.strictObject({
                line1: z.string().trim().min(1),
                line2: z.string().trim().min(1).optional(),
                line3: z.string().trim().min(1).optional(),
                postalCode: z.string().trim().min(1),
                city: z.string().trim().min(1),
                state: z.string().trim().min(1).optional(),
                countryCode: ZodTypes.Country,
              }),
              thumbnail: ZodTypes.ThumbnailFormat.optional(),
            }),
            owner: z.strictObject({
              email: z.string().email().min(1),
              password: z.string().min(1),
              firstName: z.string().min(1),
              middleName: z.string().optional(),
              lastName: z.string().min(1),
              language: ZodTypes.Language,
              isSuperuser: z.boolean().optional(),
              thumbnail: ZodTypes.ThumbnailFormat.optional(),
            }),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            organizationId: ZodTypes.Id,
            userId: ZodTypes.Id,
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
